export enum MeasureDataType {
    CURRENCY = <any>"CURRENCY",
    PERCENTAGE = <any>"PERCENTAGE",
    CALCULATED_PERCENTAGE = <any>"CALCULATED_PERCENTAGE",
    COUNT = <any>"COUNT",
    SECONDS = <any>"SECONDS"
}
